export default __webpack_public_path__ + "static/media/icon_info.ea21ef6d.svg";